import { z } from 'zod';
import { DeleteProcessConnectionResponseSchema } from './delete-process-connection.schema';
export const deleteProcessConnectionContract = {
    method: 'DELETE',
    path: '/api/v2/process/connections/:id',
    description: 'Delete a process connection',
    requestSchema: z.object({}),
    responseSchema: DeleteProcessConnectionResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            401: 'Unauthorized',
            404: 'Connection not found'
        }
    }
};

//# sourceMappingURL=delete-process-connection.contract.js.map